/**
 * Page Load Time.
 * How long did it took for my page to be loaded? (including images, etc. Basically everything that's part of the first load)
 */
import { simpleMetricFactory } from './simpleMetricFactory';
export function calculatePLT(navEntry) {
    // Nav timing lvl 2
    if (navEntry.duration > 0)
        return navEntry.duration;
    // Nav timing lvl 1
    if (navEntry.navigationStart > 0 && navEntry.loadEventEnd > 0)
        return navEntry.loadEventEnd - navEntry.navigationStart;
    return false;
}
export var getPLT = simpleMetricFactory('page.load.time', calculatePLT);
